import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Spinner from 'components/shared/Spinner';
import RgbDisplay from 'components/shared/RgbDisplay';

type CartProductImageProps = {
  id: number;
  index: number;
  thumbUrl?: string | null;
  photoFilenames: { id: number; filename: string }[];
  canvasColor?: string;
  onShowImageGallery: (show: boolean, index: number) => void;
};

function CartProductImage({
  id,
  index,
  photoFilenames,
  canvasColor,
  onShowImageGallery,
  thumbUrl,
}: CartProductImageProps) {
  const [isListHidden, setIsListHidden] = useState(true);

  return (
    <div className="product_image_wrap">
      {thumbUrl === 'error' && (
        <span
          className="product_image image-load-error"
          title="Failed to load preview. Refresh page to try again."
          data-testid="thumbnail-load-error"
        >
          <FontAwesomeIcon icon="exclamation-circle" size="2x" />
        </span>
      )}
      {thumbUrl && thumbUrl !== 'error' && (
        <button
          onClick={() => {
            onShowImageGallery(true, index);
          }}
          className="product_image"
        >
          <img src={thumbUrl} id={`${id}`} alt="" data-testid="cart-product-image" />
        </button>
      )}
      {!thumbUrl && (
        <Spinner
          style={{
            width: '160px',
            height: '160px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '2px',
            border: '1px solid rgba(255, 255, 255, 0.25)',
          }}
        />
      )}
      <div className="product_image_filenames">
        {photoFilenames.map((photo, i) => {
          return (
            <div
              key={photo.id}
              className={`product_image_filename ${i > 1 ? 'hidden' : ''}`}
              title={photo.filename}
            >
              {photo.filename}
            </div>
          );
        })}
        {photoFilenames.length > 2 && (
          <button
            className="toggle_product_image_filenames unbutton nm"
            onClick={() => setIsListHidden(!isListHidden)}
          >
            {isListHidden ? 'Show More' : 'Show Less'}
          </button>
        )}
      </div>
      {canvasColor && <RgbDisplay color={canvasColor} />}
    </div>
  );
}

export default CartProductImage;
